import firebase from "firebase/compat/app";
import "firebase/compat/auth";

import React from "react";
import { render } from "react-dom";
import TagManager from 'react-gtm-module'

import App from "./component/core/App";
import { loadScript } from "./utility/dom";
import config from "./config";

// Suppress Material-UI fade deprecation warning from @material-ui/pickers
// This is a known issue in @material-ui/pickers v4 alpha versions
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Material-UI: The `fade` color utility was renamed to `alpha`')
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

if (location.host === "app.master.cargotic.com") {
  window.location.href = "https://app.cargotic.com";
}
// Carrier links in old PDFs and emails point here; the portal moved with the
// same tokens, so keep path, query and hash.
if (location.host === "documents.cargotic.app") {
  window.location.replace(
    `https://documents-cargotic.wereldo.app${location.pathname}${location.search}${location.hash}`
  );
}
const tagManagerArgs = {
  gtmId: config.tagManager.trackingId
}

const main = async () => {
  if (config.googleAnalytics.url) {
    await loadScript(config.googleAnalytics.url);
  }
  if (config.firebase) {
    firebase.initializeApp(config.firebase);
  }

  if (config.tagManager.trackingId) {
    TagManager.initialize(tagManagerArgs);
  }

  render(<App />, document.querySelector("#app"));
};

main();
